module.exports = __webpack_public_path__ + "img/nj-responsible-gambling.ad0044f8.png";